"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdFilter = void 0;
var tslib_1 = require("tslib");
var AdvancedFilter_1 = require("./AdvancedFilter");
var IdFilter = /** @class */ (function (_super) {
    tslib_1.__extends(IdFilter, _super);
    function IdFilter(fields) {
        var _this = _super.call(this) || this;
        if (typeof fields === 'object') {
            Object.assign(_this, fields);
        }
        return _this;
    }
    return IdFilter;
}(AdvancedFilter_1.AdvancedFilter));
exports.IdFilter = IdFilter;
//# sourceMappingURL=IdFilter.js.map